module.exports = __webpack_public_path__ + "img/circulo_del_pitcher.be3d856b.gif";